module.exports = "/packs/media/images/icons/bank-fa072204fd30cd7b314a54b385c93a3e.png";